import * as types from './mutation_types'
import api from '@/api/vcp'
import Cookies from '@/services/cookies'
import detector from '@/services/device-detector'
import { Queue } from '@/services/queue'

const vcpQueue = new Queue()

export const getVcpConfig = async ({ commit, rootGetters, getters, dispatch }, config) => {
  // даннные для запроса vcp-config/vcp-config-cut
  const urlParams = new URLSearchParams(window.location.search)
  const urlCmz = urlParams.get('cmz')
  const customization = rootGetters['marketing/specificQueryParams']?.cmz || urlCmz || null
  if (!rootGetters['city/getActive']) {
    await dispatch('city/getCities', {}, { root: true })
  }
  const payload = {
    cityId: config?.cityId || rootGetters['city/getActive']?.id,
    gender: rootGetters['client/profile']?.gender || 'unknown',
    isSmartphone: config?.isSmartphone || detector.isSmartphone,
    globalPlacement: config?.globalPlacement || 'landing',
    isAntiFbVersion: config?.isAntiFbVersion || false,
    cmz_H: customization,
    // brandId: 1,
    // business_product: rootGetters['enabledBusinessProduct'],
    // utm_medium: getters.utmMedium,
    // referral_dashboard_placement: rootState.route.name === 'DashboardInvite' ? 'separatepage' : (rootState.route.name === 'DashboardOrders' ? 'index' : 'leftcolumn'),
  }
  // /даннные для запроса vcp-config/vcp-config-cut
  const newVcpHash = JSON.stringify({ ...payload, isLoggedIn: rootGetters['client/isLoggedIn'] })
  const needToLoadVcp = newVcpHash !== getters.vcpHash
  commit(types.SET_VCP_HASH, newVcpHash)
  // запрос vcp-config-cut
  if (needToLoadVcp && !getters.vcpConfigLoaded) {
    // деаем запрос только если не был получен полный vcp config
    const vcpConfigInitialRequest = rootGetters['client/isLoggedIn']
      ? api.getInitialVcpConfig(payload)
      : api.getInitialVcpConfigNoAuth(payload)
    vcpConfigInitialRequest.then(response => {
      const formatedResponse = {
        1: response.data.config,
        2: response.data.config,
        3: response.data.config,
      }
      // не передаем в стор конфиг vcp-config-cut, если уже был получен полный vcp config
      if (!getters.vcpConfigLoaded) {
        commit(types.SET_VCP_CONFIG, formatedResponse)
      }
    })
  }
  // /запрос vcp-config-cut

  // запрос полного vcp config
  if (needToLoadVcp) {
    const vcpConfigRequest = rootGetters['client/isLoggedIn']
      ? vcpQueue.enqueue(() => api.getVcpConfig(payload))
      : vcpQueue.enqueue(() => api.getVcpConfigNoAuth(payload))
    vcpConfigRequest.then(response => {
      // проставляем куку кастомизации в соответствии с настройкой вцп
      let expireTime = response.data.configs?.[Object.keys(response.data.configs)?.[0]]?.Visual?.expireTime || null
      if (expireTime === null) {
        expireTime = response.data.configs?.[Object.keys(response.data.configs)?.[0]]?.NewLandingVisual?.expireTime || null
      }
      if (expireTime === null) {
        expireTime = '1'
      }
      if (customization && expireTime) {
        dispatch('setCustomization', {
          expireTime,
          customization,
        })
      }
      // проставляем флаг, означающий наличие полного конфига vcp config
      commit(types.SET_VCP_CONFIG_LOADED, true)
      commit(types.SET_VCP_CONFIG, response.data.configs)
    })
  }
  // /запрос полного vcp config
}

export const setCustomization = ({ commit, getters, rootGetters }, { expireTime, customization }) => {
  if (customization) {
    // time is string
    let time = expireTime
    if (!time) time = '1'
    time = parseInt(time)

    if (time > 0) {
      Cookies.set('cmz', customization, {
        expires: time,
      })
    } else {
      Cookies.remove('cmz')
    }
  }
}

export const changeCurrentTarget = ({ commit, getters }, newTarget) => {
  commit(types.SET_CURRENT_TARGET, newTarget)
}

export const checkCurrentTarget = ({ dispatch, getters, rootGetters }) => {
  const targetsAssociations = {
    p1: 1,
    p2: 2,
    p3: 3,
    p5: 5, // mapVCP смотрит на 2й знак-число, и поскольку его нет, то нужно поставитть что берем по дефолту
    1: 'p1',
    2: 'p2',
    3: 'p3',
    5: 'p5', // mapVCP сотрит на 2й знак-число, и поскольку его нет, то нужно поставитть что берем по дефолту
  }
  const currentGoals = rootGetters['goals/goals']?.find(goal => {
    return goal.id === targetsAssociations[getters.currentTarget]
  })
  if (!currentGoals || currentGoals?.menuTypes?.length < 1) {
    const newTargetId = rootGetters['goals/goals']?.find(goal => {
      return goal.menuTypes.length > 0
    })?.id
    const newTarget = newTargetId ? targetsAssociations[newTargetId] : null
    if (newTarget) {
      dispatch('changeCurrentTarget', newTarget)
    }
  }
}
